import { useTheme } from '@mui/material';
import { toast, Toaster, useToasterStore } from 'react-hot-toast';
import { useEffect } from 'react';

const TOAST_LIMIT = 3;

export const AppToaster = () => {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';

  const { toasts } = useToasterStore();

  useEffect(() => {
    toasts
      .filter((t) => t.visible)
      .filter((_, i) => i >= TOAST_LIMIT)
      .forEach((t) => toast.dismiss(t.id));
  }, [toasts]);

  const toastBg = isDark ? theme.palette.background.paper : theme.palette.primary.main;
  const textColor = '#f8fafc';

  return (
    <Toaster
      position="bottom-center"
      reverseOrder={true}
      toastOptions={{
        style: {
          background: toastBg,
          color: textColor,
          fontSize: '14px',
          borderRadius: '8px',
          padding: '8px 12px',
          maxWidth: '500px',
          border: isDark ? `1px solid ${theme.palette.divider}` : 'none',
          boxShadow: theme.shadows[6],
        },

        success: {
          duration: 3000,
          style: {
            background: toastBg,
            color: '#bbf7d0',
            border: '1px solid #22c55e',
          },
          iconTheme: {
            primary: '#22c55e',
            secondary: toastBg,
          },
        },

        error: {
          duration: 6000,
          style: {
            background: toastBg,
            color: '#fecaca',
            border: '1px solid #ef4444',
          },
          iconTheme: {
            primary: '#ef4444',
            secondary: toastBg,
          },
        },
      }}
    />
  );
};
